// TODO: refactor into smaller components

import styled, { css } from 'styled-components';

import {
    spaceMixin,
    Text,
    TextButton,
    Button,
    token,
    Paragraph,
} from '@zillow/constellation';

import { HR } from '@zillow/zrs-comet';

const getTextDecorationHover = ({ applyOnHover }) => {
    if (applyOnHover) {
        return css`
            &:hover {
                text-decoration: none;
            }
        `;
    }

    return null;
};

export const StyledCenterText = styled(Text)`
    text-align: center;
`;

export const StyledHR = styled(HR)`
    opacity: 0.4;
    margin: ${spaceMixin('lg')} 0;
`;

export const StyledTextButtonNoUnderline = styled(TextButton)`
    && {
        ${props => props.applyOnHover && getTextDecorationHover}
    }
`;

export const StyledNoBorderButton = styled(Button)`
    border: none;
    white-space: nowrap;
    font-size: ${token('fontSizes.bodySmallHeading')}px;
`;

export const StyledNoWrapButton = styled(Button)`
    white-space: nowrap;
    font-size: ${token('fontSizes.bodySmallHeading')}px;
`;

export const StyledEllipsisParagraph = styled(Paragraph)`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const StyledHiddenAnchor = styled.div`
    display: block;
    position: relative;
    top: -55px;
    visibility: hidden;
`;
